import { render, staticRenderFns } from "./CheckNumberOtp.vue?vue&type=template&id=3620fa52&scoped=true"
import script from "./CheckNumberOtp.vue?vue&type=script&lang=js"
export * from "./CheckNumberOtp.vue?vue&type=script&lang=js"
import style0 from "./CheckNumberOtp.vue?vue&type=style&index=0&id=3620fa52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3620fa52",
  null
  
)

export default component.exports